// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"16410bc4","232":"cae653e2","237":"ad064311","357":"0aae356d","526":"743df91c","787":"ac258537","872":"bcf15b81"}[chunkId] + ".chunk.js";
};